// extracted by mini-css-extract-plugin
export var circle = "_1a-2";
export var icon = "_1a-a";
export var iconHighlight = "_1a-0";
export var lg = "_1a-8";
export var md = "_1a-7";
export var outline = "_1a-4";
export var sm = "_1a-6";
export var square = "_1a-1";
export var xl = "_1a-9";
export var xs = "_1a-5";
export var xxs = "_1a-3";